import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[crmTgbotSideNavDropdownTrigger]',
  exportAs: 'crmTgbotSideNavDropdownTrigger',
})
export class SideNavDropdownTriggerDirective {
  el = inject<ElementRef<HTMLElement>>(ElementRef);
}
